import React, {useEffect,useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import {ComponentContext} from "../../contexts";
import Popup from "../Helpers/Popup";

function ExportResult(props) {
  const store = useLocalObservable(() => ({
    show_error_rows:false
  }));
  const compStore = useContext(ComponentContext);

  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  if(compStore.submit_result === null) {
    return null;
  }

  if(compStore.submit_result.answer === false) {
    return (
      <div className="tar const1">
        {!compStore.submit_result.errors || compStore.submit_result.errors.lengt == 0?(
          <div className="const1">Ошибка!</div>
        ):null}

        {compStore.submit_result.errors?(
          <div>
            {compStore.submit_result.errors.map((item)=>{
              return (
                <div>{item.str}</div>
              )
            })}
          </div>
        ):null}

      </div>
    )
  }

  return (
    <div className="">
      <div className="sc1">
        Строк экспортировано: {compStore.submit_result.answer.exported}
      </div>
    </div>
  )
};

ExportResult.defaultProps = {};

ExportResult.propTypes = {}

export default observer(ExportResult);
